<div class="p-3 pt-2 rounded-4">
    <div>
        <div class="pTitle border-0 mb-0 rounded-bottom-0 rounded-4 p-0 d-flex justify-content-between">
            <div class="p-3">Partners</div>
            <button class="btn btn-info btn-sm bg-white me-3 mt-3 mb-3" (click)="addNew()">Add New</button>
        </div>
    </div>
    <div class="container-fluid">
        <div class="row bg-white p-2 pt-0">
            <div class="col-md-12 mt-4 mb-5">
                <div class="table-responsive">
                    <ag-grid-angular style="width: 100%; height: 600px" class="ag-theme-alpine"
                        [columnDefs]="columnDefs" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)">
                    </ag-grid-angular>
                </div>
            </div>
        </div>
    </div>
</div>
